// const locale = navigator.language || navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage

export const getLocale = () => {
  // return locale
  return 'es'

}
